<template>
  <!--  设备管理-->
  <div class="dev-man">
    <Title :info="devTitle" />
    <ul class="dev-layer">
      <li v-for="(item, index) in 10" :key="index" @click="handleBtn(index)">
        <div class="image">
          <img class="icon" :src="require(`../assets/dev${index + 1}.png`)" />
          <img class="top" :src="btnTop" />
          <img class="bottom" :src="btnBottom" />
        </div>
        <div class="text">
          <span>{{ devBtnList[index] }}</span>
        </div>
        <!-- 底座样式 -->
        <!-- <div class="back-bottom">
          <div class="big"></div>
          <div class="mid"></div>
          <div class="little"></div>
        </div> -->
      </li>
    </ul>
<!--    设备统计-->
    <Title :info="staTitle" />
    <div class="dev-sta">
      <div class="statistics">
      <div class="left">
        <div class="da-round">
          <div class="mid-round">
            <div class="little-round">
              <span>
                <p class="dev-num"><i>54</i></p>
                <p>设备总数</p>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="rigth">
        <div class="top">
          <div>
            <span class="dev-num"><i>048</i></span>
            <span>在线</span>
          </div>
          <img src="@/assets/dev_sta_z.png" />
        </div>
        <div class="bottom">
          <div>
            <span class="dev-num"><i>012</i></span>
            <span>离线</span>
          </div>
          <img src="@/assets/dev_sta_l.png" />
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title";
export default {
  name: "DeviceManagementView",
  components: {
    Title,
  },
  data() {
    return {
      devTitle: {
        ico: require("./../assets/dev_title_icon.png"),
        text: "设备图层",
        english: "Device Layer",
        width: 19,
        height: 19,
      },
      staTitle: {
        ico: require("./../assets/dev_title_icon.png"),
        text: "设备统计",
        english: "Device statistics",
        width: 19,
        height: 19,
      },
      devBtnList: [
        "全部设备",
        "应急照明",
        "烟感器",
        "自动喷淋",
        "消防栓",
        "排烟扇",
        "灭火器",
        "防火卷帘门",
        "视频监控",
        "应急广播",
      ],
      // 按钮计数器，记录被选中的按钮数量
      btnAll:0,
      btnTop: require("@/assets/dev_top_back2.png"), //按钮顶部背景选中和未选中
      btnTopSe: require("@/assets/dev_top_back1.png"),
      btnBottom: require("@/assets/dev_bottom_warit.png"), //按钮底部背景选中和未选中
      btnBottomSe: require("@/assets/dev_bottom.png"),
      floor:'', // 楼层参数
      // 设备数组，参数
      devList:[],
    };
  },
  mounted() {
    window.deviceManagementViewCincle = this.deviceManagementViewCincle
    this.$floors.$on('changFloor', (data) => {
      this.floor = data
    })
    window.devHandle = this.handleBtn
  },
  methods: {
    deviceManagementViewCincle(){
      document.getElementById('iframe').contentWindow.MMAPI.equipCK(1)
    },
    // 按钮点击方法
    handleBtn(index) {
      console.log('handlebtbn',index)
      // 判断是否选中楼层如果未选中不调用
      if(this.floor){
        document.getElementById('iframe').contentWindow.MMAPI.equipCK(1)
        let dom = document.querySelectorAll(".dev-layer li"); // 获取整个dom节点
        let textDom = document.querySelectorAll(".dev-layer .text"); // 获取文字dom节点
        // 按钮单击判定
        if(index == -1 || index === 0 && dom[index].className == ""){     // 全部设备按钮未选中时
          this.btnAll = 0
          for (let i = 0; i < dom.length; i++) {
            let imgNum = Number(i) + 1;
            this.selectTure(dom[i],imgNum,textDom[i])
          }
        }else if(index === 0 && dom[0].className == "active" || !index){  // 全部按钮选中时
          for (let i = 0; i < dom.length; i++) {
            let imgNum = Number(i) + 1;
            this.selectFaluse(dom[i],imgNum,textDom[i])
          }
        }else if (dom[index].className !== "active") {  // 其他按钮未选中时
          this.selectTure(dom[index],index + 1,textDom[index])
          // 判断按钮是否全部选中
          console.log(this.btnAll,dom.length)
          if(this.btnAll == dom.length-1){
            this.selectTure(dom[0],1,textDom[0]) // 全部设备按钮选中
          }
        } else {  // 其他按钮选中时
          this.selectFaluse(dom[index],index + 1,textDom[index])
          if(this.btnAll == dom.length-1){
            this.selectFaluse(dom[0],1,textDom[0]) // 取消全部设备按钮的选中状态
          }
        }
        this.threeD(index,dom)
      }
    },
    // 选中按钮方法
    selectTure(dom,imgNum,text) {
      dom.children[0].children[0].src = require(`../assets/dev${imgNum}_back.png`);
      dom.children[0].children[1].src = this.btnTopSe;
      dom.children[0].children[2].src = this.btnBottomSe;
      text.className = "text text-active"
      dom.className = "active"
      ++this.btnAll

    },
  //  按钮取消选中
    selectFaluse(dom,imgNum,text){
      dom.children[0].children[0].src = require(`../assets/dev${imgNum}.png`);
      dom.children[0].children[1].src = this.btnTop;
      dom.children[0].children[2].src = this.btnBottom;
      text.className = "text"
      dom.className = ""
      --this.btnAll
    },
  //  单击按钮调用三维方法
    threeD(index,dom){
      // 存放icon图标的数据信息,按照面板上按钮顺序进行存储
      let iconList = ['8','6','9','17','5','3','2','1','7']
      // 全选按钮
      if(index == 0 || index == -1 || !index){
        if(dom[0].className == 'active'){
          this.devList = [...iconList]
        }else{
          this.devList =[]
        }
      }else{
        if(dom[index].className == 'active'){
          this.devList.push(iconList[index-1])
        }else{
          let list = this.devList.filter((item)=> item != iconList[index-1])
          this.devList = [...list]
        }
      }
      //  点击按钮调用三维方法
      // switch (index) {
      //   case 0:
      //     if(dom[index].className == 'active'){
      //       this.devList = [1,2,3,4,5,6,7,8,9,10,17]
      //     }else{
      //       this.devList =[]
      //     }
      //     break
      //   case 1:
      //     if(dom[index].className == 'active'){
      //       this.devList.push(8)
      //     }else{
      //       let list = this.devList.filter((item)=> item != 8)
      //       this.devList = [...list]
      //     }
      //     break
      //   case 2:
      //     if(dom[index].className == 'active'){
      //       this.devList.push(8)
      //     }else{
      //       let list = this.devList.filter((item)=> item != 8)
      //       this.devList = [...list]
      //     }
      //     break
      // }
      this.$icos.$emit('getIcon', this.devList);
     if(index!=-1){
       document.getElementById('iframe').contentWindow.MMAPI.equipLC(this.floor,this.devList)
     }
    }
  },
};
</script>
<style lang="less" scoped>
.dev-man {
  .dev-layer {
    width: 307px;
    margin: auto;
    display: grid;
    grid-template-columns: 166px 141px;
    grid-auto-rows: 125vh * 0.0926;
    li {
      display: flex;
      align-items: center;
      cursor: pointer;
      .image {
        position: relative;
        height: 85vh * 0.0926;
        width: 74.22px;
        img {
          position: absolute;
        }
        .top {
          left: 5%;
        }
        .bottom {
          bottom: 0;
        }
        .icon {
          top: 30%;
          left: 41%;
        }
      }
      .text {
        // color:#ffa710;
        color: #fff;
        margin-left: 5px;
        transform: translateY(-8px);
        span {
          display: flex;
          align-items: center;
        }
        span::before {
          content: "";
          display: block;
          width: 4.45px;
          height: 4.45px;
          border-radius: 50%;
          // background: #ffa710;
          background: #fff;
          margin-right: 5px;
        }
      }
      .text-active {
        color: #ffa710;
        span::before {
          background: #ffa710;
        }
      }
      // 底座样式
      .back-bottom {
        //   width: 74.22px;
        //   height: 30vh * 0.0926;
        //   position: relative;
        //   div{
        //     position: absolute;
        //     top: 50%;
        //     left: 50%;
        //     transform: translate(-50%,-50%);
        //   }
        //   .big {
        //     width: 74.22px;
        //     height: 74.22px;
        //     border: 1px dashed #ffa710;
        //     border-radius: 50%;
        //     transform:rotateX(70deg);
        //   }
        //   .mid {
        //     width: 65.04px;
        //     height: 65.04px;
        //     border-radius: 50%;
        //     background: rgba(255, 167, 16, 0.2);
        //     transform: rotateX(70deg);
        //   }
        //   .little{
        //     width: 52.69px;
        //     height: 52.69px;
        //     border-radius: 50%;
        //     border: 1px dashed rgba(255, 167, 16, 0.5);
        //     transform: rotateX(70deg);
        //   }
      }
    }
  }
  /*设备统计*/
  .dev-sta{
    height: 256vh * 0.0926;
    display: flex;
  }
  .statistics {
    height: 158vh * 0.0926;
    display: flex;
    align-items: center;
    margin: auto;
    .left {
      width: 157px;
      height: 134vh * 0.0926;
      background: url("../assets/dev_sta_back.png") no-repeat;
      margin-right: 30px;
      background-size: 100% 100%;
      display: flex;
      // 虚线圆形
      .da-round {
        width: 136.37px;
        height: 136.37px;
        border-radius: 50%;
        border: 1px dashed #fff;
        margin: auto;
        display: flex;
        .mid-round {
          margin: auto;
          width: 126.25px;
          height: 126.25px;
          box-sizing: border-box;
          border-radius: 50%;
          border: 8px solid #ffa710;
          display: flex;
          .little-round {
            margin: auto;
            width: 93px;
            height: 93px;
            border-radius: 50%;
            border: 1px solid rgba(255, 255, 255, 0.6);
            background: url("../assets/dev_sta_little.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            span {
              margin: auto;
            }
            p:last-child {
              font-size: 10px;
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
      }
    }
    .dev-num {
      font-size: 36px;
      font-weight: bold;
      background-image: -webkit-linear-gradient(bottom, #ffa710, #ffffff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0!important;
      i{
        padding-right: 6px;
      }
    }
    .rigth {
      .dev-num {
        font-size: 24px;
        margin-right: 6px;
      }
      span {
        font-size: 10px;
        color: rgba(255, 255, 255, 0.5);
      }
      .top {
        margin-bottom: 48vh * 0.0926;
      }
      .top,
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 114px;
      }
    }
  }
}
</style>
